import axios from 'axios';

const SecureAjax = axios.create({
    baseURL: process.env.REACT_APP_API_URL || '/',
    headers: {
        'Content-Type': 'application/json',
    }
});

SecureAjax.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem('auth_token');

        if (token) {
            token = decodeURIComponent(token);

            const cleanToken = token.replace(/^Bearer\s+/i, "");

            config.headers.Authorization = `Bearer ${cleanToken}`;
        }
        return config;
    },
    (error) => {
        const rejectionReason = error instanceof Error ? error : new Error(String(error));
        return Promise.reject(rejectionReason);
    }
);

export default SecureAjax;